import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import type { AgentScope } from "../services/PersonaConfigurationService";

const SCOPE_OPTIONS: Array<{ value: AgentScope; label: string }> = [
  { value: "all", label: "All" },
  { value: "mine", label: "Mine" },
  { value: "shared", label: "Shared with me" },
  { value: "organization", label: "Public" },
];

interface AgentScopeToggleProps {
  value: AgentScope;
  onChange: (scope: AgentScope) => void;
  /** Prefix for analytics data-attr, e.g. "assistant" or "assistant-agents". */
  dataAttrPrefix: string;
  fullWidth?: boolean;
}

/** All / Mine / Shared with me / Public filter for agent lists. */
const AgentScopeToggle = ({
  value,
  onChange,
  dataAttrPrefix,
  fullWidth,
}: AgentScopeToggleProps) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    onChange={(_, next: AgentScope | null) => {
      if (next !== null) onChange(next);
    }}
    size="small"
    fullWidth={fullWidth}
    aria-label="Filter agents by owner"
    data-testid="agent-scope-toggle"
  >
    {SCOPE_OPTIONS.map(({ value: scope, label }) => (
      <ToggleButton
        key={scope}
        value={scope}
        sx={{ textTransform: "none", px: 1.5 }}
        data-testid={`agent-scope-${scope}`}
        data-attr={`${dataAttrPrefix}:toggle:filter-agents-${scope}`}
      >
        {label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default AgentScopeToggle;
